import {QUERY_KEYS} from '@/queryClient'
import {useInfiniteQuery, UseInfiniteQueryOptions} from '@tanstack/react-query'
import {
    httpGetMedicalReportTypesByPatient,
    HttpGetMedicalReportTypesByPatientOptions,
    HttpGetMedicalReportTypesByPatientResponse
} from '../http/medicalReports.http'

export const useGetMedicalReportTypesByPatient = (
    params: HttpGetMedicalReportTypesByPatientOptions['params'],
    options?: Pick<UseInfiniteQueryOptions<HttpGetMedicalReportTypesByPatientResponse>, 'enabled'>
) =>
    useInfiniteQuery({
        queryKey: [QUERY_KEYS.MEDICAL_REPORT_TYPES_BY_PATIENT, params],
        queryFn: ({pageParam = 1}) => httpGetMedicalReportTypesByPatient({params: {...params, page: pageParam}}),
        ...options,
        initialPageParam: 1,
        getNextPageParam: ({meta}) => (meta.currentPage < meta.lastPage ? meta.currentPage + 1 : null)
    })
